<template>
    <div class="">
        <install-wizard-card>
            <template #top-header>Groups</template>
            <template #top-content>
                <p>
                    Every SoniCloud site has a default group that can see the entire site. If you want to restrict user access (by department, location, etc.), then create additional groups.
                </p>
<!--                <p>-->
<!--                    Do you have multiple teams or departments that don't need to see each others points?  If so, we-->
<!--                    recommend you use the below Groups feature to setup your teams that way later you can control-->
<!--                    visibility.-->
<!--                </p>-->
                <p>
                    If you don't need to restrict visibility with Groups, that's fine! We can skip it and come back later if you want.
                </p>
                <a>
                    <button v-if="noGroups"
                            type="button"
                            @click="skipStep"
                            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                        Skip Group Creation
                    </button>
                </a>
            </template>

            <template #body-summary>
                <div class="flex flex-wrap ml-6">
                    <div class="w-full sm:w-3/4 mr-0 sm:mr-4">Groups can be modified later, but this'll give you a head start.</div>
                    <a class="mt-4 sm:mt-0">
                        <span @click="saveAll" class="pb-1 text-blue-800 border-b border-blue-800 cursor-pointer">Save Progress</span>
                    </a>
                </div>
                <neutral-message v-if="isAddingGroup">Saving</neutral-message>
                <error-message v-if="errorDeleting">Error deleting group. Try again later</error-message>
            </template>

            <template #body-action>
                <div>
                    <div class="ml-0 sm:ml-6">
                        <div>
                            <!--Placeholder?-->
                        </div>

                        <div class="">
                            <div class="">
                                <div role="group" aria-labelledby="label-email">
                                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                                        <div>
                                            <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700" id="label-email">
                                                <p class="text-lg leading-6 font-medium text-gray-900">
                                                    Groups
                                                </p>
                                                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                                    These can be departments, buildings, etc.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="mt-4 sm:mt-0 sm:col-span-2">
                                            <p class="text-lg leading-6 font-medium text-gray-900">
                                                Users in Group
                                            </p>
                                            <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                                These are the users assigned to the corresponding group.
                                                Users can be in multiple groups.  If you want to edit the users
                                                in the group later, make sure that you are on the group.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 sm:mt-2 sm:border-t sm:border-gray-200 sm:pt-2" v-for="(group, groupIndex) in groups">
                                <div role="group" aria-labelledby="label-notifications">
                                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                                        <div class="">
                                            <div class="w-3/4 inline-block">
                                                <floating-input     :id="'group_name_' + group.id"
                                                                    v-model:value="groups[groupIndex].name"
                                                                    label="Group Name"
                                                ></floating-input>
                                            </div>

                                            <span   v-if="group.id !== 1"
                                                    @click="deleteGroup(groups[groupIndex])"
                                                    class="lnr icon-circle-minus ml-4 -mt-2 h-4 w-4 text-red-600 text-sm" />
                                        </div>
                                        <div class="sm:col-span-2">
                                            <div class="max-w-lg">
                                                <div class="mt-1 mb-1 pl-2 sm:pl-0 sm:mt-2 ml-2 sm:ml-0">
                                                    <span class="inline-block text-sm sm:hidden mb-2 border-b border-dotted">Users</span>
                                                    <div class="max-w-xs rounded-md shadow-sm">
                                                        <select2
                                                                :options="users"
                                                                :multiple="true"
                                                                :value="groups[groupIndex].users"
                                                                :name="'usersInGroup[' + group.id + ']'"
                                                                @input="updateUsersInGroup(groups[groupIndex])"
                                                        >
                                                        </select2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-6 sm:mt-5 sm:border-t sm:border-gray-200 sm:pt-5">
                                <div role="group" aria-labelledby="label-notifications">
                                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                                        <div>
                                            <div class="mb-4 text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700"
                                                 id="">
                                                <div>
                                                    <floating-input     id="new_group_name"
                                                                        v-model:value="newGroupName"
                                                                        label="New Group Name"
                                                    ></floating-input>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <div class="max-w-lg">
                                                <div class="mt-4 flex justify-between">
                                                    <button type="button"
                                                            @click="addGroup"
                                                            :disabled="isAddingGroup"
                                                            class="block items-center ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm font-sans rounded-md text-blue-700 bg-white-600 hover:bg-blue-200 focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-300">
                                                        {{ (isAddingGroup) ? 'Saving New Group' : 'Add This New Group' }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template #bottom-header>Done with groups?</template>
            <template #bottom-button>
                <a>
                    <button type="button"
                            @click="completeStep"
                            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                        <slot name="bottom-button-text">Complete and move on!</slot>
                    </button>
                </a>
            </template>
            <!--            <template #bottom-button-text></template>-->
        </install-wizard-card>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import axios from "axios";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import NeutralMessage from "@/components/NeutralMessage";
    import ErrorMessage from "@/components/ErrorMessage";
    import Select2 from "@/components/elements/select2"
    import FloatingInput from "@/components/elements/FloatingInput"

    export default {
        name: "InstallWizardGroupCreation",
        mixins: [SonicuCoreMixin],
        props: {
            users: {
                type: Object,
            },
        },
        data() {
            return {
                groups: [],
                newGroupUsers: {},
                newGroupName: '',
                isAddingGroup: false,
                errorDeleting: false,
            };
        },
        components: {ErrorMessage, NeutralMessage, InstallWizardCard, Select2, FloatingInput},
        mounted() {
            this.updateGroupsList()
        },
        methods: {
            skipStep() {
                axios.post(window.location.pathname, {}).then(function (response) {
                    window.location.href = response.data.target;
                    return true;
                })
            },
            updateGroupsList() {
                this.groups = []
                axios.get(this.company.buildCompanyApiInternalRoute('groups')).then(response => {
                    response.data.data.forEach((item, key) => {
                        this.groups.push({
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            users: Object.values(item.users),
                        })
                        this.newGroupUsers[item.id] = item.users
                    })
                })
            },
            saveAll() {
                this.groups.forEach((item, key) => {
                    this.saveGroup(item)
                })
            },
            saveGroup(group) {
                this.isAddingGroup = true
                axios.patch(this.company.buildCompanyApiInternalRoute('groups') + '/' + group.id, {
                    name: group.name,
                    description: group.description,
                    users: this.newGroupUsers[group.id],
                }).then(response => {
                    this.isAddingGroup = false
                }
                ).catch(error => {
                })
            },
            deleteGroup(group) {
                let index = this.groups.indexOf(group)
                axios.delete(this.company.buildCompanyApiInternalRoute('groups') + '/' + group.id).then(response => {

                }
                ).catch(error => {
                    this.groups.push(group)
                    this.errorDeleting = true
                })
                this.groups.splice(index, 1)
            },
            updateUsersInGroup(group) {
                this.newGroupUsers[group.id] = {}
                let elementName = "usersInGroup\\[" + group.id + "\\]"
                let val = $('[name=' + elementName + ']').val()
                val.forEach((item, key) => {
                    this.newGroupUsers[group.id][item] = parseInt(item)
                })
            },
            addGroup() {
                this.isAddingGroup = true
                let newGroup = {
                    group_name: this.newGroupName,
                    group_description: '',
                }
                axios.post(this.company.buildCompanyApiInternalRoute('groups'), newGroup).then(response => {
                    this.groups.push(response.data)
                    this.newGroupName = '';
                    this.isAddingGroup = false
                })
            },
            completeStep() {
                this.saveAll()
                axios.post(this.targetRoute, { complete: true}).then(function (response) {
                    window.location.href = response.data.target;
                    return true;
                })
            }
        },
        computed: {
            noGroups() {
                return this.groups.length === 1 && this.groups[0].name === 'default'
            },
            targetRoute: function () {
                if (this.specialRoute) {
                    return this.specialRoute;
                } else {
                    return window.location.pathname;
                }
            }
        },
    }
</script>

<style scoped>

</style>